<template>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='create_time' :columns='columns' :data-source='reportList'>
    <template v-slot:action="{ record }">
       <a target="_blank" :href="record.file_url" v-if="record.file_url">下载</a>
       <span class="s_c999" v-else>无</span>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
    :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
    @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
</template>
<script>
import { reactive, ref, toRefs } from '@vue/reactivity'
import { onMounted } from '@vue/runtime-core'
import { iscode } from '@/utils/app'
import { couponDetailReport } from "@/api/assets";
// 初始化默认筛选项数值
let defSearch = {
  limit:5,
  page:1
};
export default {
  props:{
    type:Number || String
  },
  setup(props){
    const search = ref({ ...defSearch });
      const state=reactive({
        listLoading:false,
        total:0
      })
      const columns=[
      {
        title: "导出时间",
        dataIndex: "create_time",
        key: "create_time",
      },
      {
        title: "生成进度",
        dataIndex: "status_text",
        key: "status_text",
      },
      {
        title: "有效期剩余",
        dataIndex: "last_day",
        key: "last_day",
      },
      {
        title: "数据类型",
        dataIndex: "type_text",
        key: "type_text"
      },
      {
        title: "操作",
        key: "action",
        slots: { customRender: "action" },
      },
      ]
      const reportList=ref([])
      const getList=async ()=>{
        state.listLoading=true
          let result=await couponDetailReport({...search.value,type:props.type}).then(res=>res.data).catch(error=>error)
        state.listLoading=false
        if(iscode(result)){
          reportList.value=result.data.data
          state.total=result.data.total
        }
      }
      onMounted(()=>{
        getList()
      })
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      getList();
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      getList();
    };
      return{
        ...toRefs(state),
        search,
        columns,
        reportList,
        pageCurrentChange,
        pageSizeChange
      }
  }
}
</script>